import 'jquery.easing';
import 'whatwg-fetch';  // Fetch APIのPolyfill
import $ from 'jquery';
import DpPassengerModalClass from '../../parts/dp/DpPassengerModalClass';
import PassengerModalClass from '../../parts/hotel/PassengerModalClass';
import PassengersClass from '../../parts/airplane/PassengersClass';
import Power2 from 'gsap';
import qs from 'querystring'; // node標準のQueryStringのパースライブラリ
import dayjs from 'dayjs';

/** @type {string} PC用画像ファイルへのURL（※スマフォ版は自動的にspに書き換えられます） */
// const _IMAGE_URI = '/pc/img';
const _IMAGE_URI = LtikeCommon.API.CDN_URI + '/common/pc';
/** @type {string} PC用バナー画像ファイルへのURL（※スマフォ版は自動的にspに書き換えられます） */
// const _BANNER_URI = '/pc/img';
const _BANNER_URI = LtikeCommon.API.CDN_URI + '/common/pc';

const _SESSION_KEY_MASTER_AIRPLANE_TICKET = 'le_session_master_airplane_ticket';
const _LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS = 'le_localstorage_airplane_search_params';
const _LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS = 'le_localstorage_hotel_search_params';
const _LOCALSTORAGE_KEY_DP_SEARCH_PARAMS = 'le_localstorage_dp_search_params';
const _SESSION_KEY_HOTEL_FILTER_DATA = 'le_session_hotel_filter_data';
const _LOCALSTORAGE_KEY_AIRLINE = 'le_localstorage_airline';
const _LOCALSTORAGE_KEY_HOTEL_TAB_ACTIVE = 'le_localstorage_hotel_tab_active';

const _BREAK_POINT = 768;
const _BASE_TIME = 0.8;
const _BASE_EASING = Power2.easeOut;

let _isSp = false;
const _isTouch = ('ontouchstart' in window);
const _isPointer = ('PointerEvent' in window);

let _isBreakpoint = null;

const _isSafari = (navigator.userAgent.indexOf('Safari') !== -1);
const _isiOS = navigator.userAgent.match(/(iPhone|iPod)/);
const _isAndroid = navigator.userAgent.match(/Android/);
const _isAndroidChrome = (navigator.userAgent.match(/Android/) && /Chrome/.test(navigator.userAgent) && !/Version/.test(navigator.userAgent));
const _isAndroidChromeType2 = (navigator.userAgent.match(/Android/) && /Chrome/.test(navigator.userAgent));
const _isIE = (navigator.userAgent.match(/(MSIE\s)([0-9]+\.[0-9]+)/) || navigator.userAgent.match(/Trident/));
const _isEdge = navigator.userAgent.match(/Edge/);
const _isWindows = (navigator.platform.indexOf('Win') !== -1);
const _isFirefox = navigator.userAgent.match(/(firefox)/i);

let _windowSize = { w: 0, h: 0 };

let _isYoutubeApiReady = false;
let _isSpModalOpen = false;

let _master_airplane_ticket = null;
let _master_airport_data = null;
let _master_airplane_price_list = null;
let _airplane_catalog = null;
let _airplane_search_params = {};
let _hotel_search_params = null;
let _dp_search_params = null;

Number.isNaN = Number.isNaN || (value => {
  return typeof value === 'number' && value !== value;
});

/**
 * 色々な処理詰め合わせ
 */
export default class Util {
  constructor() {
    this.name = 'Util';
  }

  /**
   * 画像ファイルへのURI
   * @return {String}
   */
  static get IMAGE_URI() {
    const uri = _IMAGE_URI;
    // htmlタグのクラスにspが含まれていた場合スマフォとして処理する。
    return $('html').hasClass('sp') ? uri.replace(/\/pc\//, '/sp/') : uri;
  }

  /**
   * バナー画像へのURI
   * @return {String}
   */
  static get BANNER_URI() {
    const uri = _BANNER_URI;
    return $('html').hasClass('sp') ? uri.replace(/\/pc\//, '/sp/') : uri;
  }

  /**
   * セッションストレージ 航空券 top.json用key
   * @example
   * //get
   * Util.SESSION_KEY_MASTER_AIRPLANE_TICKET;
   * @return {String}
   */
  static get SESSION_KEY_MASTER_AIRPLANE_TICKET() {
    return _SESSION_KEY_MASTER_AIRPLANE_TICKET;
  }

  /**
   * ローカルストレージ 航空券 検索結果保持用key
   * @example
   * //get
   * Util.LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS;
   * @return {String}
   */
  static get LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS() {
    return _LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS;
  }

  /**
   * ローカルストレージ ホテル 検索結果保持用key
   * @example
   * //get
   * Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS;
   * @return {String}
   */
  static get LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS() {
    return _LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS;
  }

  /**
   * ローカルストレージ DP 検索結果保持用key
   * @example
   * //get
   * Util.LOCALSTORAGE_KEY_DP_SEARCH_PARAMS;
   * @return {String}
   */
  static get LOCALSTORAGE_KEY_DP_SEARCH_PARAMS() {
    return _LOCALSTORAGE_KEY_DP_SEARCH_PARAMS;
  }

  /**
   * セッションストレージ ホテル 絞り込み条件保存用key
   * @example
   * //get
   * Util.SESSION_KEY_MASTER_AIRPLANE_TICKET;
   * @return {String}
   */
  static get SESSION_KEY_HOTEL_FILTER_DATA() {
    return _SESSION_KEY_HOTEL_FILTER_DATA;
  }

  /**
   * 航空券
   * @return {Object}
   */
  static get LOCALSTORAGE_KEY_AIRLINE() {
    return _LOCALSTORAGE_KEY_AIRLINE;
  }

 /**
   * 航空券 top.jsonのデータ格納
   * @example
   * //get
   * Util.MASTER_AIRPLANE_TICKET;
   * //set
   * Util.MASTER_AIRPLANE_TICKET = {};
   * @return {Object}
   */
  static get MASTER_AIRPLANE_TICKET() {
    return _master_airplane_ticket;
  }

  static set MASTER_AIRPLANE_TICKET(_data) {
    _master_airplane_ticket = _data;
  }

  /**
   * 航空券 top.jsonの空港データ
   * @example
   * //get
   * Util.MASTER_AIRPORT_DATA;
   * //set
   * Util.MASTER_AIRPORT_DATA = {};
   * @return {Object}
   */
  static get MASTER_AIRPORT_DATA() {
    return _master_airport_data;
  }
  static set MASTER_AIRPORT_DATA(_data) {
    _master_airport_data = _data;
  }

  /**
   * 航空券 top.jsonの価格データ
   * @example
   * //get
   * Util.MASTER_AIRPLANE_PRICE_LIST;
   * //set
   * Util.MASTER_AIRPLANE_PRICE_LIST = {};
   * @return {Object}
   */
  static get MASTER_AIRPLANE_PRICE_LIST() {
    return _master_airplane_price_list;
  }
  static set MASTER_AIRPLANE_PRICE_LIST(_data) {
    _master_airplane_price_list = _data;
  }

  /**
   * 航空券 catalog.jsonのデータ
   * @example
   * //get
   * Util.AIRPLANE_SEARCH_PARAMS;
   * //set
   * Util.AIRPLANE_SEARCH_PARAMS = {};
   * @return {Object}
   */
  static get AIRPLANE_SEARCH_PARAMS() {
    return _airplane_search_params;
  }
  static set AIRPLANE_SEARCH_PARAMS(_data) {
    _airplane_search_params = _data;
  }

  /**
   * 航空券 catalog.json 検索時のパラメータ保持
   * @example
   * //get
   * Util.AIRPLANE_CATALOG;
   * //set
   * Util.AIRPLANE_CATALOG = {};
   * @return {Object}
   */
  static get AIRPLANE_CATALOG() {
    return _airplane_catalog;
  }
  static set AIRPLANE_CATALOG(_data) {
    _airplane_catalog = _data;
  }

  /**
   * 口コミ タブの保持
   * @example
   * //get
   * Util.LOCALSTORAGE_KEY_HOTEL_TAB_ACTIVE;
   * @return {String}
   */
  static get LOCALSTORAGE_KEY_HOTEL_TAB_ACTIVE() {
    return _LOCALSTORAGE_KEY_HOTEL_TAB_ACTIVE;
  }


  /**
   * ホテル 検索内容の保持
   * @example
   * //get
   * Util.HOTEL_SEARCH_PARAMS;
   * //set
   * Util.HOTEL_SEARCH_PARAMS = {};
   * @return {Object}
   */
  static get HOTEL_SEARCH_PARAMS() {
    return _hotel_search_params;
  }
  static set HOTEL_SEARCH_PARAMS(_data) {
    _hotel_search_params = _data;
  }


  /**
   * DP 検索内容の保持
   * @example
   * //get
   * Util.DP_SEARCH_PARAMS;
   * //set
   * Util.DP_SEARCH_PARAMS = {};
   * @return {Object}
   */
  static get DP_SEARCH_PARAMS() {
    return _dp_search_params;
  }
  static set DP_SEARCH_PARAMS(_data) {
    _dp_search_params = _data;
  }

  /**
   * カレンダーのデフォルト期間(2日)
   * @example
   * //get
   * Util.DEFAULT_PERIOD;
   * @return {Number}
   */
  static get DEFAULT_PERIOD() {
    return 2;
  }

  /**
   * ブレイクポイント
   * @example
   * //get
   * const break_point = Util.BREAK_POINT;
   * @return {Number}
   */
  static get BREAK_POINT() {
    return _BREAK_POINT;
  }

  /**
   * アニメーションベースタイム
   * @example
   * //get
   * const time = Util.BASE_TIME;
   * @return {Number}
   */
  static get BASE_TIME() {
    return _BASE_TIME;
  }

  /**
   * アニメーションベースイージング
   * @example
   * //get
   * const ease = Util.BASE_EASING;
   * @return {Number}
   */
  static get BASE_EASING() {
    return _BASE_EASING;
  }

  /**
   * スマホ判定
   * @example
   * //get
   * const flag = Util.isSp;
   * @example
   * //set
   * Util.isSp = Boolean;
   * @return {Boolean}
   */
  static get isSp() {
    return _isSp;
  }
  static set isSp(_b) {
    _isSp = _b;
  }

  /**
   * ブレイクポイント判定
   * @example
   * //get
   * const flag = Util.isBreakpoint;
   * @example
   * //set
   * Util.isBreakpoint = Boolean;
   * @return {Boolean}
   */
  static get isBreakpoint() {
    return _isBreakpoint;
  }
  static set isBreakpoint(_b) {
    _isBreakpoint = _b;
  }

  /**
   * ポインターイベント有効判定
   * @example
   * //get
   * const flag = Util.isPointer;
   * @return {Boolean}
   */
  static get isPointer() {
    return _isPointer;
  }

  /**
   * タッチイベント有効判定
   * @example
   * //get
   * const flag = Util.isTouch;
   * @return {Boolean}
   */
  static get isTouch() {
    return _isTouch;
  }

  /**
   * ブラウザ判定 safari
   * @example
   * //get
   * const flag = Util.isSafari;
   * @return {Boolean}
   */
  static get isSafari() {
    return _isSafari;
  }

  /**
   * ブラウザ判定 iOS
   * @example
   * //get
   * const flag = Util.isiOS;
   * @return {Boolean}
   */
  static get isiOS() {
    return _isiOS;
  }

  /**
   * ブラウザ判定 Android
   * @example
   * //get
   * const flag = Util.isAndroid;
   * @return {Boolean}
   */
  static get isAndroid() {
    return _isAndroid;
  }

  /**
   * ブラウザ判定 Android4 かつ chrome
   * @example
   * //get
   * const flag = Util.isAndroidChrome;
   * @return {Boolean}
   */
  static get isAndroidChrome() {
    return _isAndroidChrome;
  }

  /**
   * ブラウザ判定 Android かつ chrome
   * @example
   * //get
   * const flag = Util.isAndroidChromeType2;
   * @return {Boolean}
   */
  static get isAndroidChromeType2() {
    return _isAndroidChromeType2;
  }

  /**
   * ブラウザ判定 IE
   * @example
   * //get
   * const flag = Util.isIE;
   * @return {Boolean}
   */
  static get isIE() {
    return _isIE;
  }

  /**
   * ブラウザ判定 isEdge
   * @example
   * //get
   * const flag = Util.isEdge;
   * @return {Boolean}
   */
  static get isEdge() {
    return _isEdge;
  }

  /**
   * ブラウザ判定 isFirefox
   * @example
   * //get
   * const flag = Util.isFirefox;
   * @return {Boolean}
   */
  static get isFirefox() {
    return _isFirefox;
  }

  /**
   * OS判定 isWindows
   * @example
   * //get
   * const flag = Util.isWindows;
   * @return {Boolean}
   */
  static get isWindows() {
    return _isWindows;
  }

  /**
   * ウィンドウサイズ
   * @example
   * //get
   * const object = Util.windowSize;
   * @example
   * //set
   * Util.windowSize({w:width,h:height});
   * @return {Object} w:横幅 | h:縦幅
   */
  static get windowSize() {
    return _windowSize;
  }
  static set windowSize(_obj) {
    _windowSize = _obj;
  }

  /**
   * youtubeApiReady 状態
   * @example
   * //get
   * const flag = Util.isYoutubeApiReady;
   * @example
   * //set
   * Util.isYoutubeApiReady = Boolean;
   * @return {Boolean}
   */
  static get isYoutubeApiReady() {
    return _isYoutubeApiReady;
  }
  static set isYoutubeApiReady(b) {
    _isYoutubeApiReady = b;
  }

  /**
   * スマホモーダル開閉状態
   * @example
   * //get
   * const flag = Util.isSpModalOpen;
   * @example
   * //set
   * Util.isSpModalOpen = Boolean;
   * @return {Boolean}
   */
  static get isSpModalOpen() {
    return _isSpModalOpen;
  }
  static set isSpModalOpen(b) {
    _isSpModalOpen = b;
  }


  /**
   * 配列内の重複を削除
   * @param {Array} arr
   * @example
   * const arr = Util.getUniqueArr([0,1,2,0,1,2,3]);
   * arr -> [0,1,2,3];
   * @return {Array}
   */
  static getUniqueArr(array) {
    /*
    let storage = {};
    let re = [];
    let value;
    for (let i = 0; i < arr.length; i++) {
      value = arr[i];
      if (!(value in storage)) {
        storage[value] = true;
        re.push(value);
      }
    }
    return re;
    */
    // 値をトリムする
    array.map(s => s.trim());
    return array.filter((elem, index, self) => self.indexOf(elem) === index);
  }

  /**
   * 配列をシャッフル（非破壊）
   * @example
   * const arr = [0,1,2,3,4,5,6];
   * Util.getUniqueArr(arr);
   * @param {Array} arr
   */
  static getArrayShuffle(arr) {
    let m = arr.length; let t, i;
    while (m) {
      i = Math.floor(Math.random() * m--);
      t = arr[m];
      arr[m] = arr[i];
      arr[i] = t;
    }
  }

  /**
   * ウィンドウサイズを取得（inner）
   * @example
   * const object = Util.getWindowSize();
   * @return {Object} .w:横幅 .h:縦幅 .r:密度
   */
  static getWindowSize() {
    let r = (window.devicePixelRatio) ? window.devicePixelRatio : 1;
    let w = window.innerWidth - Util.getWindowScrollWidth();
    let h = window.innerHeight;
    return { w: w, h: h, r: r };
  }

  /**
   * ScrollTopを取得
   * @example
   * const number = Util.getScrollY();
   * @return {Number}
   */
  static getScrollY() {
    return (window.scrollY == null) ?
      document.documentElement.scrollTop : window.scrollY;
  }

  /**
   * ScrollWidthを取得
   * @example
   * const number = Util.getScrollWidth();
   * @return {Number}
   */
  static getScrollWidth() {
    return (document.documentElement.scrollWidth) ?
      document.documentElement.scrollWidth : window.outerWidth;
  }

  /**
   * スクロールバーの横幅を取得
   * @example
   * const number = Util.getWindowScrollWidth();
   * @return {Number}
   */
  static getWindowScrollWidth() {
    let scrollbarElem = document.createElement('div');
    scrollbarElem.setAttribute('style', 'visibility: hidden; position: absolute; top: 0; left: 0; width: 100vw;');
    document.body.appendChild(scrollbarElem);
    let vw = window.getComputedStyle(scrollbarElem).width | 0;
    scrollbarElem.style.width = '100%';
    let pc = window.getComputedStyle(scrollbarElem).width | 0;
    document.body.removeChild(scrollbarElem);
    return vw - pc;
  }

  /**
   * SPのパスを生成
   * @param {String} src
   * @example
   * const path = Util.getSpImagePath("./img/xxx.gif");
   * path -> "./img/sp/xxx.gif"
   * @return {String}
   */
  static getSpImagePath(src) {
    /* let arr = src.split("/");
        arr.splice(arr.length - 1, 0, 'sp');
        return arr.join("/")*/
    return src;
  }

  /**
   * クリック関数へ指定するとスムーススクロールが実装される
   * @example
   * $("a").on("click",Util.onClick_anchor);
   */
  static onClick_anchor(e) {
    e.preventDefault();
    let h = $(e.currentTarget).attr('href');
    let t = $(h === '#' || h === '' ? 'html' : h);
    if (t.length === 0) {
      t = $('html');
    }
    Util.runScroll(t);
  }

  /**
   * スムーススクロールを実行
   * @param {jQueryObject} _target
   * @example
   * Util.runScroll($("#content1"));
   */
  static runScroll(_target) {
    let header = $('#g_header');// 追従ヘッダーの場合適宜修正
    let headerHegiht = (header.length > 0) ? header.outerHeight() : 0;
    let p = _target.offset().top - headerHegiht;
    const cl = _target.attr('class');
    if (cl && cl.indexOf('css_checkbox') !== -1) { p -= _target.height(); }
    $('html,body').animate({ scrollTop: p }, 350, 'easeOutCubic');
  }

  /**
   * スムーススクロールを実装
   * @param {jQueryObject} _target
   * @example
   * Util.setAnchor($("#main"));
   */
  static setAnchor(_target) {
    let t = (_target) ? _target : 'body';
    $('a[href^="#"]', t).on('click', Util.onClick_anchor);
  }

  /**
   * 引数のターゲット位置へスムーススクロールを削除
   * @param {jQueryObject} _target
   * @example
   * Util.clearAnchor($("#main"));
   */
  static clearAnchor(_target) {
    let t = (_target) ? _target : 'body';
    $('a[href^="#"]', t).off('click', Util.onClick_anchor);
  }

  /**
   * htmlにos名をclassとして挿入
   * windows => html.windows
   * mac => なし
   * @example
   * Util.setOsName();
   */
  static setOsName() {
    let name = '';
    if (navigator.platform.indexOf('Win') !== -1) {
      name = 'windows';
    }
    $('html').addClass(name);
  }

  /**
   * htmlにブラウザ名をclassとして挿入
   * Firefox => html.firefox
   * IE => html.ie
   * Edge => html.edge
   * Safari & Chrome => html.webkit
   * @example
   * Util.setBrowserName();
   */
  static setBrowserName() {
    let name = '';
    if (navigator.userAgent.match(/(firefox)/i)) {
      name = 'firefox';
    } else if (Util.isIE) {
      name = 'ie';
    } else if (Util.isEdge) {
      name = 'edge';
    } else if (navigator.userAgent.match(/(webkit)/i)) {
      name = 'webkit';
    }
    $('html').addClass(name);
  }

  /**
   * 2点間から角度を取得
   * @param {Number} p1
   * @param {Number} p2
   * @example
   * const angle = Util.getAngle(100,100);
   */
  static getAngle(p1, p2) {
    let angle = Math.atan2((p1.y - p2.y), (p1.x - p2.x)) / (Math.PI / 180);
    angle = (angle < 0) ? 360 - Math.abs(angle) : angle;
    return angle;
  }

  /**
   * 角度から四方向を判定し文字列を取得
   * @param {Number} angle
   * @example
   * const direction = Util.getDirection(Util.getAngle(100,100));
   * @return {String} left or right or down or up
   */
  static getDirection(angle) {
    if ((angle <= 45 && angle >= 0) || (angle <= 360 && angle >= 315)) {
      return 'left';
    } else if (angle >= 135 && angle <= 225) {
      return 'right';
    } else if (angle > 45 && angle < 135) {
      return 'down';
    }
    return 'up';

  }

  /**
   * cssのtransformの値をObjectへ変換
   * @param {String} v
   * @example
   * const matrix = Util.getTransfromValue($(".target").css("transform"));
   * @return {Object} scale-x,scale-y,rotate-p,rotate-m,transform-x,transform-y
   */
  static getTransfromValue(v) {
    let values = v.split('(')[1];
    values = values.split(')')[0];
    values = values.split(', ');
    let matrix = {
      'scale-x': values[0],
      'rotate-p': values[1],
      'rotate-m': values[2],
      'scale-y': values[3],
      'transform-x': values[4],
      'transform-y': values[5],
    };
    return matrix;
  }

  /**
   * urlのパラメータ取得
   * @param {String} _search デフォルトはlocation.search
   * @example
   * const params = Util.getUrlVars();
   * @return {Object}
   */
  static getUrlVars(_search) {
    const search = (_search ? _search : location.search).replace(/^(?:.+)?\?/, '');  // 値の?とそれ以前を削除
    // node標準のquerystringsパーサーを使用する実装に変更
    return qs.parse(search);
    /*
    let vars = {};
    let param = search.substring(1).split('&');
    for (let i = 0; i < param.length; i++) {
      let keySearch = param[i].search(/=/);
      let key = '';
      let isArray = false;
      if (keySearch !== -1) {
        key = decodeURI(param[i].slice(0, keySearch));
        if (key.indexOf('[]') !== -1) {
          isArray = true;
          key = key.replace('[]', '');
        }
      }
      let val = param[i].slice(param[i].indexOf('=', 0) + 1);
      if (key !== '') {
        if (isArray) {
          if (!vars[key]) { vars[key] = []; }
          vars[key].push(decodeURI(val));
        } else {
          vars[key] = decodeURI(val);
        }
      }
    }
    return vars;
    */
  }

  /**
   * apiへアクセスし戻り値を取得
   * @param {Object} params {url:} 現状はurlのみ
   * @param {Function} success 成功時の戻りの際に実行する関数
   * @param {Function} error 失敗時の戻りの際に実行する関数
   * @param {Function} finish 成否を問わず必ず実行される関数（追加）
   * @example
   * Util.apiCall("top.json",{cmd:'hoge'},()=>{},()=>{});
   */
  static apiCall(params, success, error, finish) {
    // 成否を問わずajax通信に失敗したらローディングを消したいので、FetchAPIを使用する実装に変更
    // 非対応ブラウザではpolyfillで対処

    console.log('📶 Request:' + params.url, qs.parse(params.url.split('?')[1]));

    /** @var {string} メソッド */
    const method = 'GET';
    /** @var {object} リクエストのヘッダーパラメータ */
    const headers = {
      Accept: 'application/json',
    };

    // Fetch APIを用いた実装に変更（Polyfill付き）
    fetch(params.url, { method, headers }, LtikeCommon.API.TIMEOUT)
      .then(response => {
        // 受信に成功したらJSONとして扱う
        return response.json();
      })
      .then(json => {
        // 通信成功
        console.info('🆗 Response:', json);
        if (typeof success === 'function') {
          success(json);
        }
      })
      .catch(err => {
        // 通信失敗
        if (err.name === 'AbortError') {
          // 中断の場合の処理
          console.warn('⏹ Interruption.');
          return;
        }
        console.error('🆖 Error:', err);
        if (typeof error === 'function') {
          error(err);
        } else {
          if (err.name === 'TypeError' && navigator.userAgent.indexOf("Firefox") > 0) {
            console.warn('⏹ TypeError.');
            return;
          }
          // filterItemエラー対応です
          let path = params.url;
          let match = path.match(/catalogapi.*?subitem=filteritem/g);
          if(match == null){
            // エラーが起きたときにエラーページにリダイレクト
            window.location.href = LtikeCommon.API.ERROR + '?msg=' + encodeURIComponent(err.message) + '&stack=' + encodeURIComponent(err.stack);
          }
        }
      }).finally((r) => {
        if (typeof finish === 'function') {
          finish(r);
        } else {
          // とりあえずcssローダーを消す
          // $('#preloader').hide();
        }
        console.info('🔚 Finish.', r);
      });
    /*
    $.ajax({
      url: _params.url,
      type: 'GET',
      dataType: 'json',
      timeout: LtikeCommon.API.TIMEOUT,
      cache: false,
      success: _success,
      error: _error,
    });
    */
  }

  /**
   * ゼロ埋め
   * @param {Number} _n ゼロ埋めしたい数値
   * @param {Number} _digit ゼロ埋めしたい桁数
   * @example
   * const test = Util.zeroPadding(1);
   * @return {String}
   */
  static zeroPadding(_n, _digit = 2) {
    let zero = '';
    for (let i = 0; i < _digit; i++) { zero += '0'; }
    return (zero + _n).slice(_digit * -1);
  }

  /**
   * カンマ単位付き文字へ変換
   * @param {Number} _n 数値
   * @example
   * const test = Util.zeroPadding(1);
   * @return {String}
   */
  static numberToPrice(_n) {
    return _n.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
  }

  /**
   * 曜日を返す
   * @param {dayjsObject} _dayjs
   * @returns {string}
   */
  static getWeek(_dayjs) {
    let re = '';
    const weeks = ['日', '月', '火', '水', '木', '金', '土'];
    re = weeks[_dayjs.get('day')];
    return re;
  }

  /**
   * 出発地と目的地から価格のリストを返す
   * @param {String} _dCode 出発地の空港コード
   * @param {String} _aCode 目的地の空港モード
   * @returns {Array}
   */
  static getPriceList(_dCode, _aCode) {
    const tmpPrice = Util.MASTER_AIRPLANE_PRICE_LIST[_dCode];
    let priceList = null;
    if (tmpPrice) {
      priceList = tmpPrice[_aCode];
    } else {
      if (Util.MASTER_AIRPLANE_PRICE_LIST[_aCode]) {
        priceList = Util.MASTER_AIRPLANE_PRICE_LIST[_aCode][_dCode];
      }
    }
    return priceList;
  }

  /**
   * 文字列をエスケープ
   * @param string
   * @return {string}
   */
  static getEscapeHTML(string) {
    let strings = {
      '&': '&',
      '<': '<',
      '>': '>',
      '"': '"',
      "'": "'",
      '/': '/',
      '`': '`',
      '=': '=',
    };
    return String(string).replace(/[&<>"'`=/]/g, (s) => {
      return strings[s];
    });
  }

  /**
   * ローカルストレージから航空券のパラメータを復元
   */
  static setAirplaneSearchParams() {
    /** @type {object} URLクエリ */
    const params = qs.parse(location.search.substring(1));

    /** @type {object} */
    let detail = {};

    /** @type {dayjs} デフォルトの行きの日時 */

    // 行き/帰りの日付 default
    let going = this.getAirCalenderDefaultStart().going;
    let back = this.getAirCalenderDefaultStart().back;

    if (params.seg != undefined && params.seg != null) {
      // ホテルから飛んできたときの処理
      const seg = params.seg;
      const areaAndDate = seg.split(',');

      const arrayAreaCode = areaAndDate[1].split('-')[0] ? areaAndDate[1].split('-')[0] : '';
      if (areaAndDate[0] && areaAndDate[0] !== '' && dayjs(areaAndDate[0].substring(1)).isValid()) {
        going = areaAndDate[0].substring(1);
      }
      if (areaAndDate[1].split('-')[1] && areaAndDate[1].split('-')[1] !== '' && dayjs(areaAndDate[1].split('-')[1].substring(1)).isValid()) {
        back = areaAndDate[1].split('-')[1].substring(0);
      }

      detail = {
        airport: {
          from: null,
          to: Util.MASTER_AIRPORT_DATA[arrayAreaCode],
        },
        date: {
          going: going,
          back: back,
        },
        passengers: {
          adult: params.adtnum | 0 || 1,
          child: params.chdnum | 0 || 0,
          ageList: params.chdage ? params.chdage.split(/,/) : [],
        },
        isOneWay: 0,
      };
    } else {
      // 通常の処理

      /** @type {bool} パラメータにエラーが有るかどうかのフラグ  */
      let isCalenderError = false;

      /** @type {object} ローカルストレージに保存された検索パラメータ */
      let searchParams = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS);

      if (searchParams) {
        searchParams = JSON.parse(searchParams);

        /** @type {object} 行きのデータ */
        const fromData = Util.MASTER_AIRPORT_DATA[searchParams.airport.from];
        /** @type {object} 帰りのデータ */
        const toData = Util.MASTER_AIRPORT_DATA[searchParams.airport.to];

        /** @type {int} 片道か往復か（デフォルトは2の往復） */
        const methoditinerary = searchParams.methoditinerary | 0 || 2;

        /** @type {dayjs} 入力されている行きの日 */
        let goingDate = dayjs(searchParams.date.going);
        /** @type {dayjs} 入力されている帰りの日 */
        let backDate = dayjs(searchParams.date.back);
        // 作成時間
        var createTime = searchParams.createTime;
        let createDate = new Date();
        let now = new Date();
        createDate.setTime(createTime);

        if (goingDate.isValid()) {
          if (goingDate.diff(going, 'day') < 0) {
            // 規定のスタート日より過去だったらエラー
            isCalenderError = true;
          } else if (goingDate.diff(going, 'day') === 0 && createDate.getHours() < 17 && now.getHours() > 17) {
            // 本日17時過ぎる
            isCalenderError = true;
          }
        } else {
          isCalenderError = true;
        }

        // 往復
        if (methoditinerary === 2) {
          // 規定の最終日より未来だったらエラー、帰りの日付が行きの日付より過去だったらエラー
          if (!isCalenderError && backDate.isValid()) {
            let end = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_end);
            isCalenderError = backDate.diff(end, 'day') > 0 || goingDate.diff(backDate, 'day') > 0;
          } else {
            isCalenderError = true;
          }
        }

        if (!isCalenderError) {
          going = goingDate;
          back = backDate;
        }

        detail = {
          airport: {
            from: fromData,
            to: toData,
          },
          date: {
            going: going,
            back: back,
          },
          passengers: searchParams.passengers,
          isOneWay: methoditinerary === 1,
        };
      }
    }

    Util.DP_SEARCH_PARAMS = { detail: detail };
    Util.AIRPLANE_SEARCH_PARAMS = { detail: detail };
  }

  /**
   * 行き/帰りの日付 default
   */
  static getAirCalenderDefaultStart() {

    // 行き/帰りの日付 default
    let going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.going, 'd');
    let back = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.back, 'd');

    return { going: going, back: back };
  }

  /**
   * 最安値ページ行き/帰りの日付 default
   */
  static getAirCalenderDefaultStartForLowPrice() {

    // urlに日付がある場合
    let url = new URL(window.location.href);
    let seg = url.searchParams.get("seg");

    if(seg === null){
      // 行き/帰りの日付 default
      var going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(7, 'd');
      var back = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(8, 'd');

    } else {
      // URLの日付を設定
      seg = seg.split('-')[2];
      var going = dayjs(seg);
      var back  = dayjs(seg).add(30, 'd');
    }

    return { going: going, back: back };
  }

  /**
   *カレンダー日付範囲
   */
  static getAirCalenderTerm() {

    // カレンダーは翌日以降を選択可能とする。（当日は選択不可）
    let calenderData = {
      calender_start: dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).format('YYYY-MM-DD'),
      calender_end: dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_end).format('YYYY-MM-DD'),
    };

    return calenderData;
  }

  // 日付から文字列に変換する関数
  static getStringFromDate(date) {
    var year_str = date.getFullYear();
    // 月だけ+1すること
    var month_str = ('0'+(1 + date.getMonth())).slice(-2);
    var day_str = ('0' + date.getDate()).slice(-2);
    let format_str = 'YYYYMMDD';
    format_str = format_str.replace(/YYYY/g, year_str);
    format_str = format_str.replace(/MM/g, month_str);
    format_str = format_str.replace(/DD/g, day_str);
    return format_str;
  }

  /**
   * getのパラメータから航空券のパラメータを復元
   * @param {boolean} _isDp
   */
  static setAirplaneSearchParamsForUrl(_isDp = false) {
    let isError = false;
    const urlVars = Util.getUrlVars();
    let params = {};
    params.errors = {};

    // カノニカルURLのパラメータの文字列パターン
    let canonicalPattern = new RegExp('\x5Cbseg[A-Z]{3}-[A-Z]{3}\x5Cb|\x5Cbseg[A-Z]{3}-[A-Z]{3}_[A-Z]{3}-[A-Z]{3}\x5Cb');
    let keyName = Object.keys(urlVars)[0];
    if (canonicalPattern.test(keyName)) {
      // カノニカルURLで表示する場合

      // パラメータから発地と着地を抜き出す。
      let roundTrip = keyName.replace('seg', '');
      let segments = roundTrip.split('_');

      let today = new Date();
      let now_hour = today.getHours();
      let goingDate = new Date();
      let backDate = new Date();

      if (now_hour >= 17) {
        // 17時以降の場合
        goingDate = new Date(goingDate.setDate(goingDate.getDate() + 8));
        backDate = new Date(backDate.setDate(backDate.getDate() + 9));
      } else {
        goingDate = new Date(goingDate.setDate(goingDate.getDate() + 7));
        backDate = new Date(backDate.setDate(backDate.getDate() + 8));
      }
      // 往路
      let going = segments[0] + '-' + Util.getStringFromDate(goingDate);
      let seg = going;
      urlVars.methoditinerary = 1;

      if (segments[1]) {
        // 復路
        let back = segments[1] + '-' + Util.getStringFromDate(backDate);
        seg = seg + ',' + back;
        urlVars.methoditinerary = 2;
      }
      urlVars.adtnum = 1;
      urlVars['seg'] = seg;
    }

    // 往復or片道
    let methoditinerary = urlVars.methoditinerary | 0 || 2;
    if (!(methoditinerary === 1 || methoditinerary === 2)) {
      isError = true;
      methoditinerary = 2;
    }
    if (_isDp) { methoditinerary = 2; }
    params.methoditinerary = methoditinerary;

    //　最安値ページ判定
    let path = new URL(document.URL);
    let lowestUrlMatch = path.pathname.match('/flights/domestic/lowest-price');
    let isLowestCanonical = false;
    if(lowestUrlMatch){
      methoditinerary = 1;
    }

    const isOneWay = (methoditinerary === 1);

    // 搭乗者数
    let adult = urlVars.adtnum | 0;
    if (Number.isNaN(adult)) {
      isError = true;
      adult = (_isDp) ? 2 : 1;
    }
    let child = urlVars.chdnum | 0 || 0;
    let ageList = [];
    if (urlVars.chdage) {
      const chdage = decodeURIComponent(urlVars.chdage);
      ageList = chdage.split(',');
      params.chdage = chdage;
    }
    let passengersCheck = PassengersClass.passengersCheck({ adult: adult.n, ageList: ageList });

    if (passengersCheck.isError) {
      adult = (_isDp) ? 2 : 1;
      child = 0;
      isError = true;

      params.errors.isPassengersError = true;
    }
    params.adtnum = adult | 0 || 0;
    params.chdnum = child | 0 || 0;

    let goingParams = $.extend({}, params);
    let backParams = $.extend({}, params);

    // 出発地・目的地・日付
    let goingSeg = '';
    let backSeg = '';
    let lowestCanonicalFromTo = '';
    if (urlVars.seg) {
      let seg = decodeURIComponent(urlVars.seg);
      const segArr = seg.split(',');
      goingSeg = segArr[0];
      if (!isOneWay && segArr.length > 1) {
        backSeg = segArr[1];
      }
    }else if(lowestUrlMatch){
      isLowestCanonical = true;
      lowestCanonicalFromTo = path.pathname.match(/(?<=\/)([A-Z]{3}-[A-Z]{3})/)[0];
    }
    goingParams.seg = goingSeg;
    backParams.seg = backSeg;


    // 出発地・目的地・日付、詳細を取得
    const departure = goingSeg.split('-');
    const fromCode = isLowestCanonical ? lowestCanonicalFromTo.slice(0,3) : departure[0];
    let fromData = Util.MASTER_AIRPORT_DATA[fromCode];

    const toCode = isLowestCanonical ? lowestCanonicalFromTo.slice(4,7) : departure[1];
    let toData = Util.MASTER_AIRPORT_DATA[toCode];

    if (!fromData || !toData) {
      isError = true;
      fromData = Util.MASTER_AIRPORT_DATA[LtikeCommon.AIRPLANE.DEFAULT_AIRPORT.FROM];
      toData = Util.MASTER_AIRPORT_DATA[LtikeCommon.AIRPLANE.DEFAULT_AIRPORT.TO];

      params.errors.isSegError = true;
    }

    const goingDateString = departure[departure.length - 1];
    let backDateString = null;
    if (!isOneWay) {
      // 往復
      const arrive = backSeg.split('-');
      backDateString = arrive[arrive.length - 1];
    }

    /** @type {dayjs} デフォルトの行きの日時 */
    // let going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start);

    // 行き/帰りの日付 default
    let going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.going, 'd');
    let back = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.AIRPLANE.DEFAULT_DATE.back, 'd');

    if (_isDp) {
      // DPの場合はさらに5日後にセットする。
      going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.DP.DEFAULT_DATE.going, 'd');
    }

    // 日付を調整・設定
    let goingDate = dayjs(goingDateString);
    let backDate = dayjs(backDateString);
    let isCalenderError = false;
    // console.log(from.isValid(),to.isValid());

    if (goingDate.isValid()) {
      // 規定のスタート日より過去だったらエラー
      isCalenderError = goingDate.diff(going, 'day') < 0;
    } else {
      isCalenderError = true;
    }

    if (!isOneWay) {
      // 往復
      if (!isCalenderError && backDate.isValid()) {
        let end = _isDp ?
          dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_end).add(LtikeCommon.DP.DEFAULT_DATE.going, 'd') :
          dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_end);
        // 規定の最終日より未来だったらエラー
        isCalenderError = backDate.diff(end, 'day') > 0 || goingDate.diff(backDate, 'day') > 0;
      } else {
        isCalenderError = true;
      }
    }

    if (!isCalenderError) {
      going = goingDate;
      back = backDate;
    } else {
      params.errors.isCalenderError = true;
    }

    const detail = {
      params: params,
      airport: {
        from: fromData,
        to: toData,
      },
      date: {
        going: going,
        back: back,
      },
      passengers: {
        adult: adult,
        ageList: ageList,
      },
      isOneWay: isOneWay,
      accesskey: urlVars.accesskey ? urlVars.accesskey : '',
      catalogid: urlVars.catalogid ? urlVars.catalogid : '',
      // TODO
      // airitem1id: urlVars.airitem1id ? urlVars.airitem1id : '',
      // airitem2id: urlVars.airitem2id ? urlVars.airitem2id : '',
    };

    Util.AIRPLANE_SEARCH_PARAMS = {
      detail: detail,
      going: {
        detail: detail,
        params: goingParams,
        airport: fromData,
        date: goingDate,
      },
      back: {
        detail: detail,
        params: backParams,
        airport: toData,
        date: backDate,
      },
    };

    if(isLowestCanonical) {
      // パラメータデフォルト設定
      let airportData = lowestUrlMatch.input.split('/')[4].split('-');
      Util.AIRPLANE_SEARCH_PARAMS.going.airport = Util.MASTER_AIRPORT_DATA[airportData[0]];
      Util.AIRPLANE_SEARCH_PARAMS.back.airport = Util.MASTER_AIRPORT_DATA[airportData[1]];
      Util.AIRPLANE_SEARCH_PARAMS.going.params.adtnum = 1;

      // 日付初期化
      let lowPriceDate = this.getAirCalenderDefaultStartForLowPrice();
      Util.AIRPLANE_SEARCH_PARAMS.going.date = lowPriceDate.going;
      Util.AIRPLANE_SEARCH_PARAMS.back.date = lowPriceDate.back;

      Util.AIRPLANE_SEARCH_PARAMS.going.params.seg = airportData[0] + "-"+ airportData[1] + "-" + Util.AIRPLANE_SEARCH_PARAMS.going.date.format('YYYYMMDD');
      Util.AIRPLANE_SEARCH_PARAMS.back.params.seg = airportData[1] + "-"+ airportData[0] + "-" + Util.AIRPLANE_SEARCH_PARAMS.back.date.format('YYYYMMDD');

      Util.AIRPLANE_SEARCH_PARAMS.detail.params.adult = 1;
      Util.AIRPLANE_SEARCH_PARAMS.detail.passengers.adult = 1;

      isError = false;
    }

    return isError;
  }

  /**
   * ローカルストレージからホテルのパラメータを復元
   */
  static setHotelSearchParams() {
    let searchParams = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS);
    let params = null;

    if (searchParams) {
      searchParams = JSON.parse(searchParams);

      // 行き/帰りの日付 default
      let going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.HOTEL.DEFAULT_DATE.going, 'd');
      let back = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.HOTEL.DEFAULT_DATE.back, 'd');

      // 選択された日付
      let goingDate = dayjs(searchParams.date.going);
      let backDate = dayjs(searchParams.date.back);

      if (goingDate.isValid() && backDate.isValid()) {
        let end = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_end);
        if (goingDate.diff(going, 'day') >= 0 && backDate.diff(end, 'day') <= 0 && goingDate.diff(backDate, 'day') < 0) {
          going = goingDate;
          back = backDate;
        }
      }

      params = {
        place: searchParams.place,
        date: {
          going: going,
          back: back,
        },
        passengers: searchParams.passengers,
      };
    }

    Util.HOTEL_SEARCH_PARAMS = params;
  }

  /**
   * getのパラメータからホテルのパラメータを復元
   * @param _isDp:Boolean
   */
  static setHotelSearchParamsForUrl(_isDp = false) {
    // getのパラメータを整理・調整
    let isError = false;
    let urlVars = Util.getUrlVars();
    let params = {};
    params.errors = {};

    // 目的地の取得設定
    if (urlVars.place && urlVars.regionid && urlVars.regionid_type) {
      params.place = { text: decodeURIComponent(urlVars.place), id: urlVars.regionid, type: urlVars.regionid_type };
    } else {
      params.errors.isPlaceError = true;
      params.place = (_isDp) ? null : { text: LtikeCommon.HOTEL.DEFAULT_PLACE.TEXT, id: LtikeCommon.HOTEL.DEFAULT_PLACE.ID };
    }

    // カレンダーの取得設定
    let isCalenderError = false;

    // default日付
    const defDate = (_isDp) ? LtikeCommon.DP.DEFAULT_DATE : LtikeCommon.HOTEL.DEFAULT_DATE;
    params.date = {
      going: dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(defDate.going, 'd'),
      back: dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(defDate.back, 'd'),
    };

    if (urlVars.checkindate && urlVars.checkoutdate) {
      // 選択された日付
      var goingDate = dayjs(urlVars.checkindate);
      var backDate = dayjs(urlVars.checkoutdate);

      if (goingDate.isValid() && backDate.isValid()) {
        console.log('Util hotel diff', backDate.diff(goingDate, 'day'));

        let end = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_end);
        // 規定のスタート日より過去、もしくは規定の最終日より未来だったらエラー
        isCalenderError = goingDate.diff(params.date.going, 'day') < 0 || backDate.diff(end, 'day') > 0 || goingDate.diff(backDate, 'day') >= 0;
        params.date = { going: goingDate, back: backDate };
      } else {
        isCalenderError = true;
      }
    } else {
      isCalenderError = true;
    }

    if (isCalenderError) {
      params.errors.isCalenderError = true;
    }

    // 部屋・人数を取得設定
    let isPassengerError = false;
    params.passengers = [];
    if (urlVars.roomnum) {
      const roomNum = urlVars.roomnum | 0;
      if (roomNum > 0) {
        for (let i = 0; i < roomNum; i++) {
          const n = i + 1;
          const adult = urlVars['adtnum' + n] | 0;
          if (Number.isNaN(adult)) {
            isError = true;
            break;
          } else if (adult < 1) {
            isError = true;
            break;
          }
          let child = urlVars['chdnum' + n] | 0;
          if (Number.isNaN(child)) { child = 0; }
          let ageList = [];
          if (urlVars['chdage' + n] && child > 0) {
            ageList = decodeURIComponent(urlVars['chdage' + n]).split(',');
          }
          params.passengers.push({ adult: adult, child: child, ageList: ageList });
        }

        let passengersCheck = (_isDp) ? DpPassengerModalClass.passengersCheck(params.passengers) : PassengerModalClass.passengersCheck(params.passengers);
        // console.log(passengersCheck);
        if (passengersCheck.isError) {
          isPassengerError = true;
        }
      } else {
        isPassengerError = true;
      }
    } else {
      isPassengerError = true;
    }
    if (isPassengerError) {
      params.errors.isPassengerError = true;
      params.passengers.push({ adult: 1, child: 0, ageList: [] });
    }
    // console.log(params);

    // 絞り込み：価格MIN・価格MAX
    if (urlVars.hfmin && urlVars.hfmax) {
      const valMin = urlVars.hfmin | 0;
      const valMax = urlVars.hfmax | 0;
      if (!Number.isNaN(valMin) && !Number.isNaN(valMax) && valMin < valMax) {
        params.hfmin = valMin;
        params.hfmax = valMax;
      }
    }

    // 絞り込み：価格属性
    if (urlVars.hfdispmode) {
      const val = urlVars.hfdispmode;
      if (val === 'S' || val === 'A') { params.hfdispmode = val; }
    }

    // 絞り込み：星評価
    if (urlVars.hfst5) { params.hfst5 = 1; }
    if (urlVars.hfst4) { params.hfst4 = 1; }
    if (urlVars.hfst3) { params.hfst3 = 1; }
    if (urlVars.hfst2) { params.hfst2 = 1; }
    if (urlVars.hfst1) { params.hfst1 = 1; }

    // 絞り込み：口コミ
    if (urlVars.hfrv9) { params.hfrv9 = 1; }
    if (urlVars.hfrv8) { params.hfrv8 = 1; }
    if (urlVars.hfrv5) { params.hfrv5 = 1; }
    if (urlVars.hfrv7) { params.hfrv7 = 1; }
    if (urlVars.hfrv6) { params.hfrv6 = 1; }

    // 絞り込み：施設タイプ
    if (urlVars.hffacility) {
      params.hffacility = urlVars.hffacility;
    }

    // 絞り込み：エリア
    if (urlVars.hfarea) {
      params.hfarea = urlVars.hfarea;
    }

    Util.HOTEL_SEARCH_PARAMS = params;
  }

  /**
   * ローカルストレージからDPのパラメータを復元
   * @params _isDateReset:Boolean
   */
  static setDpSearchParams(_isDateReset = true) {
    let searchParams = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_DP_SEARCH_PARAMS);
    let params = null;
    if (searchParams) {
      params = JSON.parse(searchParams);

      const fromData = Util.MASTER_AIRPORT_DATA[params.airplane.airport.from];
      const toData = Util.MASTER_AIRPORT_DATA[params.airplane.airport.to];

      params.airplane.airport = {
        from: fromData,
        to: toData,
      };
      params.airplane.isOneWay = false;

      if (_isDateReset) {
        const going = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.DP.DEFAULT_DATE.going, 'd');
        const back = dayjs(Util.MASTER_AIRPLANE_TICKET.calender_term.calender_start).add(LtikeCommon.DP.DEFAULT_DATE.back, 'd');
        const date = {
          going: going,
          back: back,
        };
        params.airplane.date = date;
        params.hotel.date = date;
      }
    }

    Util.DP_SEARCH_PARAMS = params;
  }

  /**
   * getのパラメータからDPのパラメータを復元
   */
  static setDpSearchParamsForUrl() {

    if (!Util.AIRPLANE_SEARCH_PARAMS || !Util.AIRPLANE_SEARCH_PARAMS.detail) { Util.setAirplaneSearchParamsForUrl(true); }
    if (!Util.HOTEL_SEARCH_PARAMS) { Util.setHotelSearchParamsForUrl(true); }

    const airplane = $.extend({}, Util.AIRPLANE_SEARCH_PARAMS.detail);
    const hotel = $.extend({}, Util.HOTEL_SEARCH_PARAMS);

    const urlVars = Util.getUrlVars();

    // 宿泊地を設定
    hotel.isOtherPlace = false;
    if (urlVars.other_place) { hotel.isOtherPlace = true; }
    if (hotel.errors.isPlaceError) { hotel.isOtherPlace = false; }


    // 宿泊日を設定
    hotel.isOtherDate = false;
    if (urlVars.other_date) { hotel.isOtherDate = true; }
    if (hotel.errors.isCalenderError) { hotel.isOtherDate = false; }

    // 宿泊日が設定されていた場合、フライト日程からオーバーしていないかチェックして修正
    if (hotel.isOtherDate) {
      console.log('Util isOtherDate', hotel.date.going.diff(airplane.date.going, 'day'), hotel.date.back.diff(airplane.date.back, 'day'), hotel.date.back.diff(hotel.date.going, 'day'));
      if (hotel.date.going.diff(airplane.date.going, 'day') < 0 || hotel.date.back.diff(airplane.date.back, 'day') > 0) {
        // オーバーしていた場合、フライト日程に揃える
        hotel.date = airplane.date;
      }
    }

    Util.DP_SEARCH_PARAMS = {
      airplane: airplane,
      hotel: hotel,
    };
  }

  /**
   * ローカルストレージ 取得
   * @param {String} _key
   */
  static localstrageGetItem(_key) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.localStorage) {
      return;
    }
    const _val = window.localStorage.getItem(_key);
    console.log('📖 Load "' + _key + '" from 📙 LocalStorage:', JSON.parse(_val));
    return _val;
  }

  /**
   * ローカルストレージ設定
   * @param {String} _key
   * @param {String} _val
   */
  static localstrageSetItem(_key, _val) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.localStorage) {
      return;
    }
    console.log('💾 Save "' + _key + '" to 📙 LocalStorage: ', JSON.parse(_val));
    window.localStorage.setItem(_key, _val);
  }

  /**
   * セッションストレージ取得
   * @param {String} _key
   */
  static sessionStorageGetItem(_key) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.sessionStorage) {
      return;
    }
    const _val = window.sessionStorage.getItem(_key);
    console.log('📖 Load "' + _key + '" from 📘 SesionStorage: ', JSON.parse(_val));
    return _val;
  }

  /**
   * セッションストレージ設定
   * @param {String} _key
   * @param {String} _val
   */
  static sessionStorageSetItem(_key, _val) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.sessionStorage) {
      return;
    }
    console.log('💾 Save "' + _key + '" to 📘 SesionStorage :', JSON.parse(_val));
    window.sessionStorage.setItem(_key, _val);
  }

  /**
   * dp、ホテルのbusiness_calender開始日、終わり日、デファルトの日程を取得
   * @param {String} _flag
   */
  static calenderParamGet(_flag) {
    let topJson = JSON.parse(Util.sessionStorageGetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET));

    let default_date = _flag === 'dp' ? LtikeCommon.DP.DEFAULT_DATE : LtikeCommon.HOTEL.DEFAULT_DATE;

    var calender_term = {
      calender_start: dayjs().add(default_date.going, 'd').format('YYYY-MM-DD'),
      calender_end: dayjs().add(1, 'y').format('YYYY-MM-DD'),
    };
    var defaultSearchDate = {
      going: dayjs().add(default_date.going, 'd'),
      back: dayjs().add(default_date.back, 'd'),
    };

    let startDefault = dayjs(dayjs().format('YYYYMMDD'));
    if (topJson.calender !== undefined) {
      var goingCount = dayjs().hour() >= 17 ? default_date.going + 1 : default_date.going;
      if (_flag !== 'dp') {
        // Hotelの場合
        for (let i = 0; i < topJson.calender.length; i++) {
          if (dayjs(topJson.calender[i].settingdate).diff(startDefault, 'day') > 0 && topJson.calender[i].businessdayflag === '1') {
            goingCount--;
          }
          if (goingCount === 0) {
            calender_term.calender_start = topJson.calender[i].settingdate;
            break;
          }
        }
      } else {
        // DPの場合
        calender_term.calender_start = dayjs().add(goingCount, 'd').format('YYYY-MM-DD');
      }
      defaultSearchDate = {
        going: dayjs(calender_term.calender_start),
        back: dayjs(calender_term.calender_start).add(1, 'd'),
      };
    }

    return {
      calender_term: calender_term,
      defaultSearchDate: defaultSearchDate,
    };
  }

  /**
   * DefaultのCheckin,Checkout日付取得
   * @param {String} syflg
   *
   */
  static getDefaultSettingDate(_flag) {
    var defaultDate = {
      going: '',
      back: '',
    };

    if (_flag === 'dp') {
      let plus_date = LtikeCommon.DP.DEFAULT_DATE;
      defaultDate = {
        going: dayjs().add(plus_date.going, 'd').format('YYYYMMDD'),
        back: dayjs().add(plus_date.back, 'd').format('YYYYMMDD'),
      };
    } else if (_flag === 'hotel') {
      let startDefault = dayjs().format('YYYYMMDD');
      var goingCount = LtikeCommon.HOTEL.DEFAULT_DATE.going;
      let topJson = JSON.parse(Util.sessionStorageGetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET));
      for (let i = 0; i < topJson.calender.length; i++) {
        if (dayjs(topJson.calender[i].settingdate).diff(startDefault, 'day') > 0 && topJson.calender[i].businessdayflag === '1') {
          goingCount--;
        }
        if (goingCount === 0) {
          defaultDate.going = topJson.calender[i].settingdate;
          defaultDate.back = dayjs(defaultDate.going).add(1,'d').format('YYYYMMDD');
          break;
        }
      }
    } else if (_flag === 'flight') {
      let plus_date = LtikeCommon.AIRPLANE.DEFAULT_DATE;
      defaultDate = {
        going: dayjs().add(plus_date.going, 'd').format('YYYYMMDD'),
        back: dayjs().add(plus_date.back, 'd').format('YYYYMMDD'),
      };
    }

    return defaultDate;
  }

  /**
   * DPの30分後航空券検索結果一覧URL取得
   * @param {Array} _params
   * @param {Date} alertdatetime
   */
  static getDPReloadUrl(_params,alertdatetime) {

    var input = [];

    var reTime = new Date();

    if (dayjs(alertdatetime.setMinutes(alertdatetime.getMinutes() - 30)).hour() < 17 && dayjs(reTime).hour() >= 17) {
      let default_date = this.getDefaultSettingDate('dp');
      let aigoing = _params.airplane.date.going;
      let aiback = _params.airplane.date.back;
      let htgoing = _params.hotel.date.going;
      let htback = _params.hotel.date.back;
      if (dayjs(default_date.going).diff(_params.airplane.date.going,'d') === 0 && dayjs(default_date.back).diff(_params.airplane.date.back,'d') === 0) {
        aigoing = dayjs(_params.airplane.date.going).add(1, 'd').format('YYYYMMDD');
        aiback = dayjs(aigoing).add(1, 'd').format('YYYYMMDD');
      } else if (dayjs(default_date.going).diff(_params.airplane.date.going,'d') === 0 && dayjs(default_date.back).diff(_params.airplane.date.back,'d') > 0) {
        aigoing = dayjs(_params.airplane.date.going).add(1, 'd').format('YYYYMMDD');
        if (dayjs(_params.airplane.date.back).diff(aigoing,'d') <= 0) {
          aiback = dayjs(aigoing).add(1, 'd').format('YYYYMMDD');
        }
      }

      if (dayjs(htgoing).diff(aigoing,'d') < 0) {
        htgoing = aigoing;
      }

      if (dayjs(htback).diff(htgoing,'d') <= 0) {
        htback = dayjs(htgoing).add(1, 'd').format('YYYYMMDD');
      }

      let from = _params.airplane.airport.from.code + '-' + _params.airplane.airport.to.code + '-' + aigoing;
      let to  = _params.airplane.airport.to.code + '-' + _params.airplane.airport.from.code + '-' + aiback;
      input.push('seg=' + from + '%2C' + to);
      input.push('checkindate=' + dayjs(htgoing).format('YYYYMMDD'));
      input.push('checkoutdate=' + dayjs(htback).format('YYYYMMDD'));
      let searchParams = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_DP_SEARCH_PARAMS);
      if (searchParams) {
        searchParams = JSON.parse(searchParams);
        searchParams.airplane.date.going = aigoing;
        searchParams.airplane.date.back = aiback;
        searchParams.hotel.date.going = dayjs(htgoing).format('YYYYMMDD');
        searchParams.hotel.date.back = dayjs(htback).format('YYYYMMDD');
        Util.localstrageSetItem(Util.LOCALSTORAGE_KEY_DP_SEARCH_PARAMS, JSON.stringify(searchParams));
      }
    } else {
      let from = _params.airplane.airport.from.code + '-' + _params.airplane.airport.to.code + '-' + _params.airplane.date.going;
      let to = _params.airplane.airport.to.code + '-' + _params.airplane.airport.from.code + '-' + _params.airplane.date.back;
      input.push('seg=' + from + '%2C' + to);
      input.push('checkindate=' + _params.hotel.date.going);
      input.push('checkoutdate=' + _params.hotel.date.back);
    }

    let passengers = this.getChdList(_params.hotel.passengers);

    for (var i = 0 ; i < passengers.length; i++) {
      input.push(passengers[i]);
    }

    let url = '/dp/domestic/search_result/flights?' + input.join('&');

    return url;
  }

  static getChdList(passengers) {
    var input = [];
    var adtnum = passengers.length;

    for (let i = 0; i < adtnum; i++) {
      const r = passengers[i];

      input.push('adtnum' + (i + 1) + '=' + r.adult);

      if (r.ageList !== undefined) {
        var chdnum = 0;
        var infnum = 0;
        var chdage = [];
        var infage = [];
        var checkageList = decodeURIComponent(r.ageList).split(',');

        for (var age = 0; age < checkageList.length; age++) {
          if (checkageList[age].length > 0 && checkageList[age] !== '') {
            if (Number(checkageList[age]) >= 2) {
              chdnum = chdnum + 1;
              chdage.push(checkageList[age]);
            } else {
              infnum = infnum + 1;
              infage.push(checkageList[age]);
            }
          }
        }

        if (chdnum > 0) {
          input.push('chdnum' + (i + 1) + '=' + chdnum);
          input.push('chdage' + (i + 1) + '=' + chdage.join(','));
        }
        if (infnum > 0) {
          input.push('infnum' + (i + 1) + '=' + infnum);
          input.push('infage' + (i + 1) + '=' + infage.join(','));
        }
      }
    }
    input.push('roomnum=' + adtnum);

    return input;
  }
  /**
   * ホテルプラン詳細の30分後ホテル検索結果一覧URL取得
   * @param {Array} _params
   * @param {Date} alertdatetime
   */
  static getHotelsReloadUrl(_params,alertdatetime) {
    var input = [];
    var reTime = new Date();
    input.push('place=' + _params.place.text);
    input.push('regionid=' + _params.place.id);

    if (dayjs(alertdatetime.setMinutes(alertdatetime.getMinutes() - 30)).hour() < 17 && dayjs(reTime).hour() >= 17) {
      let default_date = this.getDefaultSettingDate('hotel');
      let topJson = JSON.parse(Util.sessionStorageGetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET));
      let going = _params.date.going;
      let back = _params.date.back;
      for (let i = 0; i < topJson.calender.length; i++) {
        if (dayjs(topJson.calender[i].settingdate).diff(_params.date.going, 'day') > 0 && topJson.calender[i].businessdayflag === '1') {
          going = topJson.calender[i].settingdate;
          break;
        }
      }

      if (dayjs(default_date.going).diff(_params.date.going,'d') === 0 && dayjs(default_date.back).diff(_params.date.back,'d') === 0) {
        back = dayjs(going).add(1, 'd').format('YYYYMMDD');
      } else if (dayjs(default_date.going).diff(_params.date.going,'d') === 0 && dayjs(default_date.back).diff(_params.date.back,'d') > 0) {
        if (dayjs(_params.date.back).diff(going,'d') > 0) {
          back =dayjs(_params.date.back).format('YYYYMMDD');
        } else {
          back = dayjs(going).add(1, 'd').format('YYYYMMDD');
        }

      } else {
        going = dayjs(_params.date.going).format('YYYYMMDD');
        back = dayjs(_params.date.back).format('YYYYMMDD');
      }

      input.push('checkindate=' + dayjs(going).format('YYYYMMDD'));
      input.push('checkoutdate=' + dayjs(back).format('YYYYMMDD'));

      let searchParams = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS);
      if (searchParams) {
        searchParams = JSON.parse(searchParams);
        searchParams.date.going = going;
        searchParams.date.back = back;
        Util.localstrageSetItem(Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS, JSON.stringify(searchParams));
      }
    } else {
      input.push('checkindate=' + dayjs(_params.date.going).format('YYYYMMDD'));
      input.push('checkoutdate=' + dayjs(_params.date.back).format('YYYYMMDD'));
    }

    let passengers = this.getChdList(_params.passengers);

    for (var i = 0 ; i < passengers.length; i++) {
      input.push(passengers[i]);
    }

    input.push('prod=hotel');
    input.push('m=c');
    let url = '/hotels/domestic/search_result?' + input.join('&');

    return url;
  }

  /**
   * の30分後航空券検索結果一覧URL取得
   * @param {Array} _params
   * @param {Date} alertdatetime
   */
  static getFlightsReloadUrl(_params,alertdatetime) {
    var input = [];
    var reTime = new Date();
    input.push('methoditinerary=' + _params.methoditinerary);
    input.push('adtnum=' + _params.passengers.adult);
    input.push('chdnum=' + _params.passengers.ageList.length);
    let agelist = '';
    if (_params.passengers.ageList.length > 0) {
      agelist = _params.passengers.ageList.join(',');
    }
    input.push('chdage=' + agelist);
    if (dayjs(alertdatetime.setMinutes(alertdatetime.getMinutes() - 30)).hour() < 17 && dayjs(reTime).hour() >= 17) {
      let default_date = this.getDefaultSettingDate('flight');
      let dategoing = _params.date.going;
      let dateback = _params.date.back;
      if (_params.methoditinerary === 1) {
        if (dayjs(default_date.going).diff(_params.date.going,'d') === 0) {
          dategoing = dayjs(_params.date.going).add(1,'d').format('YYYYMMDD');
          let from = _params.airport.from + '-' + _params.airport.to + '-' + dategoing;
          input.push('seg=' + from);
        }
      } else if (_params.methoditinerary === 2) {
        if (dayjs(default_date.going).diff(_params.date.going,'d') === 0 && dayjs(default_date.back).diff(_params.date.back,'d') === 0) {
          dategoing = dayjs(_params.date.going).add(1,'d').format('YYYYMMDD');
          dateback = dayjs(_params.date.back).add(1,'d').format('YYYYMMDD');
        } else if (dayjs(default_date.going).diff(_params.date.going,'d') === 0 && dayjs(default_date.back).diff(_params.date.back,'d') > 0) {
          dategoing = dayjs(_params.date.going).add(1,'d').format('YYYYMMDD');
          if (dayjs(_params.airplane.date.back).diff(dategoing,'d') <= 0) {
            dateback = dayjs(dategoing).add(1,'d').format('YYYYMMDD');
          }
        }
        let from = _params.airport.from + '-' + _params.airport.to + '-' + dategoing;
        let to = _params.airport.to + '-' + _params.airport.from + '-' + dateback;
        input.push('seg=' + from + '%2C' + to);
      }

      let searchParams = Util.localstrageGetItem(Util._LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS);
      if (searchParams) {
        searchParams = JSON.parse(searchParams);
        searchParams.date.going = dategoing;
        searchParams.date.back = dateback;
        searchParams.createTime = new Date().getTime();
        Util.localstrageSetItem(Util._LOCALSTORAGE_KEY_AIRPLANE_SEARCH_PARAMS, JSON.stringify(searchParams));
      }
    } else {

      let from = _params.airport.from + '-' + _params.airport.to + '-' + _params.date.going;
      if (_params.methoditinerary === 1) {
        input.push('seg=' + from);
      } else if (_params.methoditinerary === 2) {
        let to = _params.airport.to + '-' + _params.airport.from + '-' + _params.date.back;
        input.push('seg=' + from + '%2C' + to);
      }
    }

    input.push('accesskey=0');
    input.push('catalogid=0');
    input.push('airflg=1');
    let url = '/flights/domestic/search_result?' + input.join('&');

    return url;
  }
}
